<div class="min-h-screen flex items-start justify-center w-full">
  <div class="p-12 md:p-32 bg-white rounded-2xl shadow-l w-full">
    <div class="flex gap-x-6 items-center justify-start py-12 my-16">
      <fun-new-button size="s" (eventClick)="switchView('year')" [buttonType]="viewMode === 'year' ? 'primaryDark' : 'secondaryDark'" title="Anual"></fun-new-button>
      <fun-new-button size="s" (eventClick)="switchView('month')" [buttonType]="viewMode === 'month' ? 'primaryDark' : 'secondaryDark'" title="Mensual"></fun-new-button>
    </div>

    <ng-container *ngIf="viewMode === 'year'">
      <div class="grid gap-24 md:grid-cols-3 xl:grid-cols-4">
        <ng-container *ngFor="let m of yearlyCalendar">
          <div class="flex flex-col gap-6 min-h-[230px]">                       <!-- altura fija -->
            <!-- Título del mes -->
            <h3 class="text-l font-sans text-eggplant-100 capitalize">
              {{ monthNames[m.month] }}
            </h3>
            <!-- Mini‑calendario -->
            <div class="grid grid-cols-7 text-center gap-y-1 text-s text-eggplant-70">
              <!-- cabecera de días -->
              <span *ngFor="let d of dayNames" class="font-sans font-medium text-s">{{ d | lowercase }}</span>
              <!-- celdas de días -->
              <ng-container *ngFor="let day of m.days">
                <!-- huecos vacíos -->
                <span *ngIf="!day" class="py-1"></span>

                <!-- día real -->
                <span *ngIf="day" class="py-1 relative inline-flex items-center justify-center font-sans text-s cursor-pointer" [ngClass]="getStatusColorClass(day.status)"
                (click)="onYearDayClick(m.year, m.month, day.day)">
                  {{ day.day }}
                </span>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="viewMode === 'month'">
      <div class="flex items-center justify-between mb-32">
        <div class="flex items-center justify-center gap-12">
          <fun-icon [name]="'calendar'" [style]="'stroke-[4px] stroke-eggplant-100 w-[20px] h-[20px]'"></fun-icon>
          <h2 class="text-h500 font-sans text-eggplant-100">{{ getMonthYearTitle() }}</h2>
        </div>
        <div class="flex items-center gap-8">
          <div (click)="goToPreviousMonth()">
            <fun-icon [name]="'chevron-left'"
            [style]="isPreviousMonthDisabled() ? 'stroke-[4px] stroke-gray-10 w-[24px] h-[24px]' : 'stroke-[4px] stroke-eggplant-80 w-[24px] h-[24px] cursor-pointer'"></fun-icon>
          </div>
          <fun-new-button size="m" (eventClick)="goToToday()" icon="" iconPosition="" [buttonType]="'ghost'" title="{{ 'CALENDAR.TODAY' | translate }}"></fun-new-button>
          <div (click)="goToNextMonth()">
            <fun-icon [name]="'chevron-right'"
            [style]="isNextMonthDisabled() ? 'stroke-[4px] stroke-gray-10 w-[24px] h-[24px]' : 'stroke-[4px] stroke-eggplant-80 w-[24px] h-[24px] cursor-pointer'"></fun-icon>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-7 gap-4 mb-4">
        <p *ngFor="let day of dayNames" class="p-6 text-center text-m md:text-l font-sans text-eggplant-70"> {{ day }}</p>
      </div>

      <div class="grid grid-cols-7 gap-6">
        <div
          *ngFor="let dayData of calendarDaysGrid"
          class="min-h-72 md:h-[132px] rounded-xl transition-all duration-200 ease-in-out flex flex-col items-start relative overflow-hidden cursor-pointer"
          [ngClass]="{
            'bg-cream-10 hover:bg-cream-40': dayData.isCurrentMonth && !isSelectedDayInGrid(dayData.date),
            'bg-gray-10 text-gray-40 opacity-70 !cursor-not-allowed': !dayData.isCurrentMonth,
            'bg-eggplant-10': isSelectedDayInGrid(dayData.date)
          }"
          (click)="dayData.isCurrentMonth && onDayClick(dayData.date)"
        >
          <p class="text-m font-sans pt-6 pl-6"
            [ngClass]="{
              'text-eggplant-80': dayData.isCurrentMonth && !isTodayDay(dayData.date),
              'text-gray-40': !dayData.isCurrentMonth
            }"
          >{{ dayData.dayOfMonth }}</p>

          <div class="space-y-1 w-full flex-grow overflow-y-auto scrollbar-thin scrollbar-thumb-eggplant-70 scrollbar-track-cream-10 rounded">
            <ng-container *ngIf="dayData.payments.length > 0">
              <p *ngFor="let payment of dayData.payments"
                  class="text-s px-2 md:py-1 rounded w-full text-center font-sans flex items-center justify-center"
                  [ngClass]="getPaymentStatusClass(payment.status)"
                  [title]="payment.title + ' ' + payment.amount.toFixed(2) + ' € ' + ' (' + statusConfig[payment.status]?.label + ')'"
              >
                {{ payment.amount === 0 ? 'Por determinar' : payment.amount | currency: 'EUR': 'symbol': '1.2-2' }}
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selectedDate">
      <div #detailContainer class="mt-48 p-12 md:p-24 rounded-xl border border-gray-10 shadow-m">
        <h3 class="text-h500 font-sans text-eggplant-100 mb-24">{{ 'CALENDAR.PAYS_FOR' | translate }} {{ formatSelectedDayDate() }}</h3>
        <ng-container *ngIf="selectedDatePayments.length > 0; else noPaymentsForSelectedDay">
          <div *ngFor="let payment of selectedDatePayments" class=" py-12 border-b border-gray-10 last:border-b-0">
            <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between ">
              <div class="mb-2 sm:mb-0">
                <p
                  class="px-6 pt-2 rounded-full text-s font-sans text-center uppercase w-fit"
                  [ngClass]="getPaymentStatusClass(payment.status)"
                >
                  {{ statusConfig[payment.status]?.label }}
                </p>
                <p class="font-sans text-eggplant-80 text-l md:text-xl">{{ payment.title }}</p>
                <p class="font-sans text-s text-eggplant-100/[0.55]">{{ payment.project }}</p>
              </div>
              <div class="flex items-center">
                <p *ngIf="payment.amount > 0" class="font-sans text-eggplant-80 text-l md:text-xl">{{ payment.amount | currency: 'EUR': 'symbol': '1.2-2' }}</p>
                <p *ngIf="payment.amount === 0" class="font-sans text-eggplant-100/[0.55] text-l md:text-xl">Por determinar</p>
              </div>
            </div>
            <div class="w-full pt-12">
              <p class="font-sans text-m md:text-l text-eggplant-100">{{ payment.description }}</p>
            </div>
          </div>
        </ng-container>
        <ng-template #noPaymentsForSelectedDay>
          <p class="font-sans text-eggplant-70 text-center py-6 text-l">{{ 'CALENDAR.NO_PROGRAMATED_PAYS' | translate }}</p>
        </ng-template>
      </div>
    </ng-container>

    <div class="mt-48 mb-24 flex flex-wrap gap-x-24 gap-y-12 font-sansMedium justify-center">
      <div class="flex items-center gap-2">
        <div class="w-24 h-12 rounded-xl bg-cream-100"></div>
        <p class="font-sans text-l text-eggplant-70">{{ 'CALENDAR.PAID' | translate }}</p>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-24 h-12 rounded-xl bg-active"></div>
        <p class="font-sans text-l text-eggplant-70">{{ 'CALENDAR.PENDING' | translate }}</p>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-24 h-12 rounded-xl bg-eggplant-70"></div>
        <p class="font-sans text-l text-white-100">{{ 'CALENDAR.DELAY' | translate }}</p>
      </div>
      <div class="flex items-center gap-2">
        <div class="w-24 h-12 rounded-xl bg-orange-100"></div>
        <p class="font-sans text-l text-white-100">{{ 'CALENDAR.CANCELED' | translate }}</p>
      </div>
    </div>
  </div>
</div>